import MasterApi from './MasterApi';

export default class VoyageMasterSvc extends MasterApi {
  constructor() {
    super();
    this.masterPrefix = '';
    this.masterName = 'voyage/master';
  }

  async getById(id) {
    return this.get(id);
  }
}
